<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<h1>Help Center</h1>
<main class="help-center">
  <div class="instruction-text" style="margin-bottom:20px;">Need more information, or need a hand? Contact us or browse our help topics.</div>
  <p-accordion [multiple]="true">
    <p-accordionTab header="Latest News" class="help-new" [selected]="true" id="help-new">
      <h5><a href="https://www.atworksys.com/onelynk-release-notes/" target="_blank" alt="OneLynk's Release Notes">View OneLynk's Latest Release Notes</a></h5>
    </p-accordionTab>
    <p-accordionTab header="Contact Us" class="help-contact" [selected]="true" id="help-contact">
      <h5>Contact Us</h5>

      <div class="help-box">
        <div>
          <h3>
            <a href="tel:5713765153"> 571-376-5153</a>
          </h3>
          <div>M-F 9am-5pm Eastern</div>
          <h5>
            <a href="mailto:support@atworksys.com?subject=AtWork Support E-Mail" target="_blank">Support@AtWorkSys.com</a>
          </h5>
        </div>
        <div>

          <h3>Connect Chat Support</h3>
          <div>M-F 9am-5pm Eastern</div>
          <div style="margin-top:7px;">
            <a (click)="initiateConnectSupport()">
              <button class="icon-action">
                <i class="fa fa-comments" style="font-size:30px;"></i>
              </button>
            </a>
          </div>
        </div>
      </div>
      <h4></h4>
    </p-accordionTab>

    <p-accordionTab header="User Guides" class="help-topics" [selected]="true" id="user-guides">
      <h5>User Guides</h5>
      <div class="help-overview-vid help-user-guide">
        <ul>
          <li><h6>Overview</h6>
            <a class="secondary-action" href="/assets/help/QR-Overview.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (1.2MB)</a>
          </li>
          <li><h6>Payroll</h6>
            <a class="secondary-action" href="/assets/help/QR-Payroll.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (2.3MB)</a>
          </li>
          <li><h6>Accounting System Setup</h6>
            <a class="secondary-action" style="margin-right:10px;" href="/assets/help/QR-Accounting-System-Setup.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (1.2MB)</a>
            <a class="secondary-action" href="/assets/help/Accounting-System-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> User Guide (10.8MB)</a>
          </li>
          <li><h6>Accounts Payable</h6>
            <a class="secondary-action" href="/assets/help/QR-Accounts-Payable.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (2.5MB)</a>
          </li>
          <li><h6>Accounts Receivable</h6>
            <a class="secondary-action" href="/assets/help/QR-Accounts-Receivable.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (1.9MB)</a>
          </li>
          <li><h6>Expense Reports</h6>
            <a class="secondary-action" href="/assets/help/QR-Expense-Reports.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (<1MB)</a>
          </li>
          <li><h6>Contract &amp; Projects</h6>
            <a class="secondary-action" style="margin-right:10px;" href="/assets/help/QR-Contract-Setup.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Contract Quick Reference (1.4MB)</a>
            <a class="secondary-action" href="/assets/help/QR-Project-Setup.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Project Quick Reference (1.5MB)</a><br>
            <a class="secondary-action" href="/assets/help/Contracts-and-Projects-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Contract &amp; Project User Guide (5.3MB)</a>
          </li>
          <li><h6>Workflow &amp; Worklist</h6>
            <a class="secondary-action" href="/assets/help/QR-Workflow-Worklist.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (1MB)</a>
          </li>
        </ul>
        <ul>
          <li><h6>Human Capital Management | Hire2Retire</h6>
            <a class="secondary-action" style="margin-right:10px;" href="/assets/help/QR-HCM.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (1.5MB)</a>
            <a class="secondary-action" href="/assets/help/HCM-Hire2Retire-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> User Guide (2.6MB)</a>
          </li>

          <li><h6>Recruit2Hire</h6>
            <a class="secondary-action" href="/assets/help/HCM-Recruit2Hire-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> User Guide (2MB)</a>
          </li>
          <li><h6>General Ledger</h6>
            <a class="secondary-action" href="/assets/help/QR-General-Ledger.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (2.3MB)</a>
          </li>
          <li><h6>Procure2Pay | Purchase Order</h6>
            <a class="secondary-action" style="margin-right:10px;" href="/assets/help/QR-Purchase-Order.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (<1MB)</a>
            <a class="secondary-action" href="/assets/help/Procure2Pay-Process-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> User Guide (6.7MB)</a>
          </li>
          <li><h6>Order to Cash | Sales Orders</h6>
            <a class="secondary-action" href="/assets/help/Order2Cash-Process-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> User Guide (4.3MB)</a>
          </li>
          <li><h6>Self Service - ESS, MSS</h6>
            <a class="secondary-action" style="margin-right:10px;" href="/assets/help/QR-Self-Service-ESS-MSS.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (1MB)</a>
            <a class="secondary-action" href="/assets/help/HCM-Self-Service-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> User Guide (4.5MB)</a>
          </li>
          <li><h6>Timesheet &amp; Expenses</h6>
            <a class="secondary-action" style="margin-right:10px;" href="/assets/help/QR-Timesheet.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> Quick Reference (1MB)</a>
            <a class="secondary-action" href="/assets/help/Time-and-Expense-User-Guide.pdf" target="_blank"><i class="fa fa-file-pdf-o"></i> User Guide (3MB)</a>
          </li>


        </ul>
      </div>
      <div class="main-clear">&nbsp;</div>
      <h4></h4>
    </p-accordionTab>
    <p-accordionTab header="Video Help" class="vid-help" [selected]="true" id="vid-help">
      <h5 class="p-col-12">Video Help</h5>
      <div class="p-col-12 help-overview-vid">
        <h6>OneLynk Overview</h6>
        <ul>
          <li>
            <a (click)="helpGettingStarted=true">Getting Started</a>
          </li>
          <li>
            <a (click)="helpNavigating=true">Navigation</a>
          </li>
          <li>
            <a (click)="helpEssMssHcm=true">Employees, Managers &amp; HCM</a>
          </li>
          <li>
            <a (click)="helpConvertingResources=true">Converting Resources</a>
          </li>
          <li>
            <a (click)="helpTimeExpense=true">Time &amp; Expense</a>
          </li>
          <li>
            <a (click)="helpBidsContracts=true">Bids &amp; Contracts</a>
          </li>

        </ul>
        <ul>
          <li>
            <a (click)="helpEstimatesProjects=true">Estimates &amp; Projects</a>
          </li>
          <li>
            <a (click)="helpProcurementOrders=true">Procurement &amp; Orders</a>
          </li>
          <li>
            <a (click)="helpFinancePayroll=true">Finance &amp; Payroll</a>
          </li>
          <li>
            <a (click)="helpAnalytics=true">Analytics &amp; Reporting</a>
          </li>
          <li>
            <a (click)="displayJ=true">Settings &amp; Solutions</a>
          </li>
        </ul>
      </div>
      <div class="p-col-12 help-box">
        <div>
          <ul>
            <li>
              <h6>Expense Reports</h6>
            </li>
            <li>
              <a (click)="helpExpenseOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpExpenseAdd=true">How do I add an expense report?</a>
            </li>
            <li>
              <a (click)="helpExpenseEnter=true">How do I enter expenses?</a>
            </li>
            <li>
              <a (click)="helpExpenseUpload=true">How do I upload receipts?</a>
            </li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Timesheets</h6>
            </li>
            <li>
              <a (click)="helpTimesheetOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpTimesheetView=true">How do I fill out my timesheet?</a>
            </li>
            <li>
              <a (click)="helpTimesheetSubmit=true">How do I sign and submit?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Purchase Requsitions</h6>
            </li>
            <li>
              <a (click)="helpPurchaseReqOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpPurchaseReqCreate=true">How do I create a Purchase Requisition?</a>
            </li>
            <li>
              <a (click)="helpPurchaseReqSubmit=true">How do submit for approval?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>

        <div>
          <ul>
            <li>
              <h6>Worklist</h6>
            </li>
            <li>
              <a (click)="helpWorklistOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpWorklistView=true">How do I view my Worklist?</a>
            </li>
            <li>
              <a (click)="helpWorklistManage=true">How do manage Worklist items?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Attachments &amp; Supporting Documents</h6>
            </li>
            <li>
              <a (click)="helpAttachmentsOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpAttachmentsUpload=true">How do I upload and save a file?</a>
            </li>
            <li>
              <a (click)="helpAttachmentsReplace=true">How do I replace a file?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>ToDos</h6>
            </li>
            <li>
              <a (click)="helpToDosOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpToDosAddTasks=true">How do I add tasks?</a>
            </li>
            <li>
              <a (click)="helpToDosUpdateTasks=true">How do I move &amp; update tasks?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Estimates</h6>
            </li>
            <li>
              <a (click)="helpEstimatesOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpEstimatesAdd=true">How do I add an estimate?</a>
            </li>
            <li>
              <a (click)="helpEstimatesLaborCategories=true">How do I manage labor categories &amp; tasks?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Projects</h6>
            </li>
            <li>
              <a (click)="helpProjectsOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpProjectsAdd=true">How do I add a project?</a>
            </li>
            <li>
              <a (click)="helpProjectsLaborCategories=true">How do I manage labor categories, tasks, &amp; resources?</a>
            </li>
            <li><a (click)="helpProjectsApprovals=true">How do I get approvals and make mods?</a></li>
            <li><a (click)="helpProjectsGantt=true">How do I use the Gantt chart?</a></li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Connect</h6>
            </li>
            <li>
              <a (click)="helpConnectOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpConnectPeer=true">How do I connect to a peer?</a>
            </li>
            <li>
              <a (click)="helpConnectGroup=true">How do I connect to a group?</a>
            </li>
            <li>
              <a (click)="helpConnectSupport=true">How do I connect to Chat Support?</a>
            </li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Financial Calendar</h6>
            </li>
            <li>
              <a (click)="helpCalendarOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpCalendarSetup=true">How do I setup a financial calendar?</a>
            </li>
            <li>
              <a (click)="helpCalendarHoliday=true">How do I setup a holiday calendar?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Charge Codes</h6>
            </li>
            <li>
              <a (click)="helpChargeCodesOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpChargeCodesAccoutGroups=true">How do I learn about Account Groups and mapping?</a>
            </li>
            <li>
              <a (click)="helpChargeCodesAddGroups=true">How do I add an Account Group?</a>
            </li>
            <li>
              <a (click)="helpChargeCodesAdd=true">How do I add a charge code?</a>
            </li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Financial Setup</h6>
            </li>
            <li>
              <a (click)="helpFinancialSetupOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpFinancialSetupChartAccounts=true">How do I setup a Chart of Accounts?</a>
            </li>
            <li>
              <a (click)="helpFinancialSetupCostPools=true">How do I manage Cost Pools?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Work Authorization</h6>
            </li>
            <li>
              <a (click)="helpWorkAuthOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpWorkAuthCreate=true">How do I create an authorization?</a>
            </li>
            <li>
              <a (click)="helpWorkAuthResources=true">How do I authorize resources?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <h6>Bids &amp; Proposals</h6>
            </li>
            <li>
              <a (click)="helpBidsOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpBidsCreate=true">How do I create a bid?</a>
            </li>
            <li>
              <a (click)="helpBidsLaborCategories=true">How do I manage Labor Categories?</a>
            </li>
            <li>&nbsp;</li>
          </ul>
        </div>

        <div>
          <ul>
            <li>
              <h6>Contracts</h6>
            </li>
            <li>
              <a (click)="helpContractsOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpContractsCreate=true">How do I create a contract?</a>
            </li>
            <li>
              <a (click)="helpContractsOptions=true">How do I manage Options, CLINs and SLAs?</a>
            </li>
            <li>
              <a (click)="helpContractsLaborCategories=true">How do I manage Labor Categories and Milestones?</a>
            </li>
          </ul>
        </div>

        <div>
          <ul>
            <li>
              <h6>Item Catalog</h6>
            </li>
            <li>
              <a (click)="helpItemCatalogOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpItemCatalogManage=true">How do I manage catalogs?</a>
            </li>
            <li>
              <a (click)="helpItemCatalogAddItems=true">How do I add items?</a>
            </li>
            <li>
              &nbsp;
            </li>
          </ul>
        </div>

        <div>
          <ul>
            <li>
              <h6>Item Receipt &amp; Item Return</h6>
            </li>
            <li>
              <a (click)="helpItemReceiptOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpItemReceiptManage=true">How do I manage item receipts?</a>
            </li>
            <li>
              <a (click)="helpItemReceiptReturns=true">How do I manage item returns?</a>
            </li>
            <li>
              &nbsp;
            </li>
          </ul>
        </div>

        <div>
          <ul>
            <li>
              <h6>Vendor Setup</h6>
            </li>
            <li>
              <a (click)="helpVendorsOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpVendorsAdd=true">How do I add vendors?</a>
            </li>
            <li>
              <a (click)="helpVendorsManage=true">How do I manage contacts, payment terms, and info?</a>
            </li>
            <li>
              <a (click)="helpVendorsTransactions=true">How do I manage vendor transactions?</a>
            </li>
          </ul>
        </div>

        <div>
          <ul>
            <li>
              <h6>Customer Setup</h6>
            </li>
            <li>
              <a (click)="helpCustomersOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpCustomersSetup=true">How do I setup a customer?</a>
            </li>
            <li>
              <a (click)="helpCustomersContacts=true">How do I add contacts</a>
            </li>
            <li>
              <a (click)="helpCustomersPayments=true">How do I add payment terms</a>
            </li>
            <li>
              <a (click)="helpCustomersSalesTax=true">How do I add sales tax info?</a>
            </li>
          </ul>
        </div>

        <div>
          <ul>
            <li>
              <h6>Accounts Payable</h6>
            </li>
            <li>
              <a (click)="helpAccountsPayableOverview=true">How do I see an overview?</a>
            </li>
            <li>
              <a (click)="helpAccountsPayableBills=true">How do I manage bills?</a>
            </li>
            <li>
              <a (click)="helpAccountsPayableManage=true">How do I manage line items, receipts &amp; returns?</a>
            </li>
            <li>
              <a (click)="helpAccountsPayablePayments=true">How do I make payments?</a>
            </li>
          </ul>
        </div>

      </div>
      <div class="main-clear"></div>
      <h4></h4>
    </p-accordionTab>
    <p-accordionTab header="Automated Clearing House (ACH) FAQs" class="ach" [selected]="true" id="ach">

      <app-ach-faq></app-ach-faq>
    </p-accordionTab>
  </p-accordion>

  <!--Overview -->
  <p-dialog header="Show Me | Overview: Getting Started" [(visible)]="helpGettingStarted" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpGettingStarted" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Navigation" [(visible)]="helpNavigating" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpNavigating" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=149;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Employees, Managers and HCM" [(visible)]="helpEssMssHcm" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpEssMssHcm" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=380;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Time &amp; Expense" [(visible)]="helpTimeExpense" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpTimeExpense" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=544;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Bids &amp; Contracts" [(visible)]="helpBidsContracts" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpBidsContracts" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=589;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Estimates &amp; Projects" [(visible)]="helpEstimatesProjects" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpEstimatesProjects" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=635;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Procurement &amp; Orders" [(visible)]="helpProcurementOrders" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpProcurementOrders" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=676;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Finance &amp; Payroll" [(visible)]="helpFinancePayroll" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpFinancePayroll" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=749;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Analytics &amp; Reporting" [(visible)]="helpAnalytics" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAnalytics" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=810;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Overview: Settings & Solutions" [(visible)]="displayJ" [modal]="true" [responsive]="true">
    <iframe *ngIf="displayJ" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=845;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Expense Reports -->
  <p-dialog header="Show Me | Expense Reports: Overview" [(visible)]="helpExpenseOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpExpenseOverview" width="560" height="315" src="https://www.youtube.com/embed/FrgwqYW7Nfc?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
    </iframe>
  </p-dialog>
  <p-dialog header="Show Me | Expense Reports: How to Add an Expense Report" [(visible)]="helpExpenseAdd" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpExpenseAdd" width="560" height="315" src="https://www.youtube.com/embed/FrgwqYW7Nfc?start=110;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Expense Reports: How to Add Expenses to an Expense Report" [(visible)]="helpExpenseEnter" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpExpenseEnter" width="560" height="315" src="https://www.youtube.com/embed/FrgwqYW7Nfc?start=233;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Expense Reports: How to Upload Receipts" [(visible)]="helpExpenseUpload" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpExpenseUpload" width="560" height="315" src="https://www.youtube.com/embed/FrgwqYW7Nfc?start=625;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>


  <!-- Timesheets -->
  <p-dialog header="Show Me | Timesheets: Overview" [(visible)]="helpTimesheetOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpTimesheetOverview" width="560" height="315" src="https://www.youtube.com/embed/-BM_k4HN69Y?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Timesheets: How to Use My Timesheet" [(visible)]="helpTimesheetView" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpTimesheetView" width="560" height="315" src="https://www.youtube.com/embed/-BM_k4HN69Y?start=82;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Timesheets: How to Sign &amp; Submit" [(visible)]="helpTimesheetSubmit" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpTimesheetSubmit" width="560" height="315" src="https://www.youtube.com/embed/-BM_k4HN69Y?start=303;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Purchase Req -->
  <p-dialog header="Show Me | Purchase Requisitions: Overview" [(visible)]="helpPurchaseReqOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpPurchaseReqOverview" width="560" height="315" src="https://www.youtube.com/embed/4tg3f3v_8a4?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Purchase Requisitions: Creating a Purchase Requisition" [(visible)]="helpPurchaseReqCreate" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpPurchaseReqCreate" width="560" height="315" src="https://www.youtube.com/embed/4tg3f3v_8a4?start=217;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Purchase Requsitions: Submitting a Purchase Requisition" [(visible)]="helpPurchaseReqSubmit" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpPurchaseReqSubmit" width="560" height="315" src="https://www.youtube.com/embed/4tg3f3v_8a4?start=821;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Workgroups -->
  <p-dialog header="Show Me | WorkGroups: Overview" [(visible)]="helpWorklistOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpWorklistOverview" width="560" height="315" src="https://www.youtube.com/embed/XusBB1Kiq1w?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
    </iframe>
  </p-dialog>
  <p-dialog header="Show Me | WorkGroups: Your Worklist" [(visible)]="helpWorklistView" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpWorklistView" width="560" height="315" src="https://www.youtube.com/embed/XusBB1Kiq1w?start=287;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | WorkGroups: Managing a Worklist Item" [(visible)]="helpWorklistManage" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpWorklistManage" width="560" height="315" src="https://www.youtube.com/embed/XusBB1Kiq1w?start=491;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Attachments -->
  <p-dialog header="Show Me | Attachments &amp; Documents: Overview" [(visible)]="helpAttachmentsOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAttachmentsOverview" width="560" height="315" src="https://www.youtube.com/embed/6gDrIKW8HSA?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Attachments &amp; Documents: Uploading &amp; Saving Files" [(visible)]="helpAttachmentsUpload" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAttachmentsUpload" width="560" height="315" src="https://www.youtube.com/embed/6gDrIKW8HSA?start=140;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Attachments &amp; Documents: Replacing Files" [(visible)]="helpAttachmentsReplace" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAttachmentsReplace" width="560" height="315" src="https://www.youtube.com/embed/6gDrIKW8HSA?start=190;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- ToDos -->
  <p-dialog header="Show Me | ToDos: Overview" [(visible)]="helpToDosOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpToDosOverview" width="560" height="315" src="https://www.youtube.com/embed/Uh-mugZLgeo?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | ToDos: Adding Tasks" [(visible)]="helpToDosAddTasks" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpToDosAddTasks" width="560" height="315" src="https://www.youtube.com/embed/Uh-mugZLgeo?start=116;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | ToDos: Moving &amp; Updating Tasks" [(visible)]="helpToDosUpdateTasks" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpToDosUpdateTasks" width="560" height="315" src="https://www.youtube.com/embed/Uh-mugZLgeo?start=177;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Estimates -->
  <p-dialog header="Show Me | Estimates: Overview" [(visible)]="helpEstimatesOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpEstimatesOverview" width="560" height="315" src="https://www.youtube.com/embed/E8CSnM3U_zg?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Estimates: Adding &amp; Managing Estimates" [(visible)]="helpEstimatesAdd" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpEstimatesAdd" width="560" height="315" src="https://www.youtube.com/embed/E8CSnM3U_zg?start=165;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Estimates: Labor Categories &amp; Tasks" [(visible)]="helpEstimatesLaborCategories" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpEstimatesLaborCategories" width="560" height="315" src="https://www.youtube.com/embed/E8CSnM3U_zg?start=472;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Connect -->
  <p-dialog header="Show Me | Connect: Overview" [(visible)]="helpConnectOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpConnectOverview" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Connect: Connecting to a Peer" [(visible)]="helpConnectPeer" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpConnectPeer" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=131;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Connect: Connecting to a Group" [(visible)]="helpConnectGroup" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpConnectGroup" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=218;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Connect: Connectin to Chat Support" [(visible)]="helpConnectSupport" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpConnectSupport" width="560" height="315" src="https://www.youtube.com/embed/vp0syC4t0Jo?start=298;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Calendar -->
  <p-dialog header="Show Me | Calendar: Overview" [(visible)]="helpCalendarOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCalendarOverview" width="560" height="315" src="https://www.youtube.com/embed/BBxsONC9IHo?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Calendar: Setting Up a Financial Calendar" [(visible)]="helpCalendarSetup" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCalendarSetup" width="560" height="315" src="https://www.youtube.com/embed/BBxsONC9IHo?start=53;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Calendar: Setting Up a Holiday Calendar" [(visible)]="helpCalendarHoliday" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCalendarHoliday" width="560" height="315" src="https://www.youtube.com/embed/BBxsONC9IHo?start=326;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Charge Codes -->
  <p-dialog header="Show Me | Charge Codes: Overview" [(visible)]="helpChargeCodesOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpChargeCodesOverview" width="560" height="315" src="https://www.youtube.com/embed/1UBJQY5JTv0?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Charge Codes: Account Groups &amp; Mapping" [(visible)]="helpChargeCodesAccoutGroups" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpChargeCodesAccoutGroups" width="560" height="315" src="https://www.youtube.com/embed/1UBJQY5JTv0?start=276;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Charge Codes: Adding an Account Group" [(visible)]="helpChargeCodesAddGroups" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpChargeCodesAddGroups" width="560" height="315" src="https://www.youtube.com/embed/1UBJQY5JTv0?start=598;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Charge Codes: Adding a Charge Code" [(visible)]="helpChargeCodesAdd" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpChargeCodesAdd" width="560" height="315" src="https://www.youtube.com/embed/1UBJQY5JTv0?start=713;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Financial Setup -->
  <p-dialog header="Show Me | Financial Setup: Overview" [(visible)]="helpFinancialSetupOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpFinancialSetupOverview" width="560" height="315" src="https://www.youtube.com/embed/LF-sNaoce0w?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Financial Setup: Chart of Accounts" [(visible)]="helpFinancialSetupChartAccounts" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpFinancialSetupChartAccounts" width="560" height="315" src="https://www.youtube.com/embed/LF-sNaoce0w?start=172;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Financial Setup: Managing Cost Pools" [(visible)]="helpFinancialSetupCostPools" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpFinancialSetupCostPools" width="560" height="315" src="https://www.youtube.com/embed/LF-sNaoce0w?start=624;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Work Auth -->
  <p-dialog header="Show Me | Work Authorization: Overview" [(visible)]="helpWorkAuthOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpWorkAuthOverview" width="560" height="315" src="https://www.youtube.com/embed/cZmkcF4BQsw?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Work Authorization: Creating an Authorization" [(visible)]="helpWorkAuthCreate" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpWorkAuthCreate" width="560" height="315" src="https://www.youtube.com/embed/cZmkcF4BQsw?start=95;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Work Authorization: Authorizing Resources" [(visible)]="helpWorkAuthResources" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpWorkAuthResources" width="560" height="315" src="https://www.youtube.com/embed/cZmkcF4BQsw?start=219;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!--Contracts -->
  <p-dialog header="Show Me | Contracts: Overview" [(visible)]="helpContractsOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpContractsOverview" width="560" height="315" src="https://www.youtube.com/embed/mah6rgqr5nY?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Contracts: Creating a Contract" [(visible)]="helpContractsCreate" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpContractsCreate" width="560" height="315" src="https://www.youtube.com/embed/mah6rgqr5nY?start=99;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Contracts: Options, CLINs &amp; SLAs" [(visible)]="helpContractsOptions" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpContractsOptions" width="560" height="315" src="https://www.youtube.com/embed/mah6rgqr5nY?start=601;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Contracts: Labor Categories &amp; Milestones" [(visible)]="helpContractsLaborCategories" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpContractsLaborCategories" width="560" height="315" src="https://www.youtube.com/embed/mah6rgqr5nY?start=1103;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!--Bids -->
  <p-dialog header="Show Me | Bids &amp; Proposals: Overview" [(visible)]="helpBidsOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpBidsOverview" width="560" height="315" src="https://www.youtube.com/embed/mhYvTePSTTA?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Bids &amp; Proposals: Creating a Bid" [(visible)]="helpBidsCreate" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpBidsCreate" width="560" height="315" src="https://www.youtube.com/embed/mhYvTePSTTA?start=182;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Bids &amp; Proposals: Managing Labor Categories" [(visible)]="helpBidsLaborCategories" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpBidsLaborCategories" width="560" height="315" src="https://www.youtube.com/embed/mhYvTePSTTA?start=306;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!--Projects -->
  <p-dialog header="Show Me | Projects: Overview" [(visible)]="helpProjectsOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpProjectsOverview" width="560" height="315" src="https://www.youtube.com/embed/hmij8gGlpxk?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Projects: Adding a Project" [(visible)]="helpProjectsAdd" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpProjectsAdd" width="560" height="315" src="https://www.youtube.com/embed/hmij8gGlpxk?start=269;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Projects: Labor Categories, Tasks, &amp; Resources" [(visible)]="helpProjectsLaborCategories" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpProjectsLaborCategories" width="560" height="315" src="https://www.youtube.com/embed/hmij8gGlpxk?start=481;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Projects: Approvals &amp; Mods" [(visible)]="helpProjectsApprovals" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpProjectsApprovals" width="560" height="315" src="https://www.youtube.com/embed/hmij8gGlpxk?start=1128;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Projects: Gantt Chart" [(visible)]="helpProjectsGantt" [modal]="true" [responsive]="true">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/88r6h7gFWpA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </p-dialog>
  <!--Item Catalog -->
  <p-dialog header="Show Me | Item Catalog: Overview" [(visible)]="helpItemCatalogOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpItemCatalogOverview" width="560" height="315" src="https://www.youtube.com/embed/JhMIwgx44NQ?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Item Catalog: Managing Catalogs" [(visible)]="helpItemCatalogManage" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpItemCatalogManage" width="560" height="315" src="https://www.youtube.com/embed/JhMIwgx44NQ?start=155;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Item Catalog: Adding Items" [(visible)]="helpItemCatalogAddItems" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpItemCatalogAddItems" width="560" height="315" src="https://www.youtube.com/embed/JhMIwgx44NQ?start=366;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!--Item Receipt & Return -->
  <p-dialog header="Show Me | Item Receipt &amp; Return: Overview" [(visible)]="helpItemReceiptOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpItemReceiptOverview" width="560" height="315" src="https://www.youtube.com/embed/9mn0-KYcUIA?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Item Receipt &amp; Return: Managing Receipts" [(visible)]="helpItemReceiptManage" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpItemReceiptManage" width="560" height="315" src="https://www.youtube.com/embed/9mn0-KYcUIA?start=54;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Item Receipt &amp; Return: Managing Returns" [(visible)]="helpItemReceiptReturns" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpItemReceiptReturns" width="560" height="315" src="https://www.youtube.com/embed/9mn0-KYcUIA?start=198;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Vendor Setup -->
  <p-dialog header="Show Me | Vendors: Overview" [(visible)]="helpVendorsOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpVendorsOverview" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Vendors: Adding Vendors" [(visible)]="helpVendorsAdd" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpVendorsAdd" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=106;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Vendors: Contacts, Payment Terms &amp; Info" [(visible)]="helpVendorsManage" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpVendorsManage" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=240;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Vendors: Transactions " [(visible)]="helpVendorsTransactions" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpVendorsTransactions" width="560" height="315" src="https://www.youtube.com/embed/4qF7MazB_MQ?start=513;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Accounts Payable -->
  <p-dialog header="Show Me | Accounts Payable: Overview" [(visible)]="helpAccountsPayableOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAccountsPayableOverview" width="560" height="315" src="https://www.youtube.com/embed/QafurvRAPkc?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me |Accounts Payable: Managing Bills" [(visible)]="helpAccountsPayableBills" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAccountsPayableBills" width="560" height="315" src="https://www.youtube.com/embed/QafurvRAPkc?start=188;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me |Accounts Payable: Managing Line Items, Receipts &amp; Returns" [(visible)]="helpAccountsPayableManage" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAccountsPayableManage" width="560" height="315" src="https://www.youtube.com/embed/QafurvRAPkc?start=336;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Accounts Payable: Making Payments" [(visible)]="helpAccountsPayablePayments" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpAccountsPayablePayments" width="560" height="315" src="https://www.youtube.com/embed/QafurvRAPkc?start=435;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>

  <!-- Customer Setup -->
  <p-dialog header="Show Me | Customer Setup: Overview" [(visible)]="helpCustomersOverview" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCustomersOverview" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=0;autoplay=1" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Customer Setup: Setup a Customer" [(visible)]="helpCustomersSetup" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCustomersSetup" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=30;autoplay=1" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Customer Setup: Adding Contacts" [(visible)]="helpCustomersContacts" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCustomersContacts" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=216;autoplay=1" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Customer Setup: Payment Terms" [(visible)]="helpCustomersPayments" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCustomersPayments" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=239;autoplay=1" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Customer Setup: Sales Tax" [(visible)]="helpCustomersSalesTax" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpCustomersSalesTax" width="560" height="315" src="https://www.youtube.com/embed/6zbVTBNjz-0?start=274;autoplay=1" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
  <p-dialog header="Show Me | Converting Resources" [(visible)]="helpConvertingResources" [modal]="true" [responsive]="true">
    <iframe *ngIf="helpConvertingResources" width="560" height="315" src="https://www.youtube.com/embed/Dwg8c4uI8aU?start=0;autoplay=1" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </p-dialog>
</main>
